import styled from 'styled-components';

export const AlertContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 16px;
  gap: 12px;
  background-color: #f6f6f6;
  border-radius: 12px;
  align-self: stretch;

.alert-header {
    display: flex;
    flex-direction: row;
    /* Alinha o ícone e o texto pelo topo */
    align-items: flex-start; 
    gap: 16px;
    width: 100%;
  }

  .icon-container {
    display: flex;
    /* Garante que o container do ícone não tente centralizar o conteúdo internamente */
    justify-content: flex-start;
    align-items: flex-start;
    /* Evita que o ícone "estique" ou saia do lugar se o texto for muito grande */
    flex-shrink: 0; 
  }

  .icon-ring-outer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background-color: rgba(200, 19, 27, 0.1);
  }

  .icon-ring-inner {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background-color: rgba(200, 19, 27, 0.2);
  }

  /* Conteúdo de Texto */
  .alert-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    text-align: flex-start;
  }

  .alert-title {
    margin: 0;
    font-family: 'Poppins', sans-serif;
    font-size: 18px;
    font-weight: 600;
    color: #333333;
  }

  .alert-message {
    margin: 0;
    color: var(--Takeat-Colors-Neutrals-Grey-01, #545454);

    /* Label/Label Large/Medium | 500 */
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
    letter-spacing: 0.1px;  
}

  .alert-actions {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 4px;
  }
`;